function tableOfContents() {
  const toc = document.querySelector(".js-toc");
  const tocOpen = document.querySelector(".js-toc-open");
  const tocClose = document.querySelector(".js-toc-close");
  const animateHeight = (element, height, duration) => {
    let promise;
    if (!element) {
      promise = Promise.resolve();
    } else {
      promise = new Promise((resolve) => {
        const transition = element.style.transition;
        const offsetHeight = `${element.offsetHeight}px`;
        element.style.height = offsetHeight;
        element.offsetHeight;
        element.style.transition = `height ${duration}ms`;
        requestAnimationFrame(() => {
          element.style.height = height;
        });
        const transitionend = () => {
          element.style.transition = transition;
          element.removeEventListener("transitionend", transitionend);
          resolve();
        };
        element.addEventListener("transitionend", transitionend, { once: true });
      });
    }
    return promise;
  };

  const openToc = () => {
    if (toc && tocOpen && tocClose) {
      tocOpen.style.display = "none";
      tocClose.style.display = "flex";
      toc.style.display = "flex";
      animateHeight(toc, "auto", 400);
    }
  };

  const returnPosition = () => {
    const top = toc.getBoundingClientRect().top + window.pageYOffset - 64;
    window.scrollTo({ top, behavior: "smooth" });
  };

  const closeToc = () => {
    if (toc && tocOpen && tocClose) {
      tocClose.style.display = "none";
      tocOpen.style.display = "flex";
      if (toc) {
        returnPosition();
      }
      toc.style.display = "flex";
      animateHeight(toc, "240px", 200);
    }
  };
  if (tocClose) {
    tocClose.style.display = "none";
  }

  if (tocOpen) {
    tocOpen.addEventListener("click", (event) => {
      event.preventDefault();
      openToc();
    });
  }

  if (tocClose) {
    tocClose.addEventListener("click", (event) => {
      event.preventDefault();
      closeToc();
    });
  }

  document.querySelectorAll(".js-return-toc").forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      openToc();
      returnPosition();
    });
  });
}

export { tableOfContents };
